import Marquee from "react-fast-marquee";

const items = ["Balance the Books", "Cut Supplier Costs", "Widen Margins", "Rebuild BBB Score", "Reduce Labor Spend", "Regain Control", "Retain Customers", "Scale Growth"];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee-section" className="relative py-16 border-y border-black/10 bg-[#ded9cb] overflow-hidden">
      <Marquee speed={40} gradient gradientColor="#ded9cb" gradientWidth={160}>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-head text-5xl md:text-7xl font-light tracking-tighter text-[#1e3d3a] px-10 leading-[1.25] py-2 inline-block">
              {t}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#c9a961]" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
